import { Link } from "react-router-dom";
import { ecosystemDropDownIcons } from "views/landing/constants";
import SoonBlur from "../SoonBlur";
import SoonItem from "../SoonItem";
import { useMediaQuery } from "usehooks-ts";

const EcosystemItems = () => {
  const matches = useMediaQuery("(min-width: 1024px)");

  return (
    <ul className="flex flex-col gap-[0.571vw] max-lg:gap-[2.13vw] font-luxora">
      {ecosystemDropDownIcons.map(({ icon: Icon, name, url, isBlank }) => (
        <li key={name}>
          {url === "#" ? (
            <div className="navigation-link group w-full cursor-pointer opacity-90 p-[0.571vw] max-lg:p-[2.13vw] flex items-center gap-[0.8vw] max-lg:gap-[3.2vw] rounded-2xl">
              {matches ? <SoonBlur /> : <SoonItem />}
              <div className="size-[2vw] max-lg:size-[7.46vw] font-luxora-regular flex items-center justify-center rounded-lg bg-white shadow-custom">
                <div>
                  <Icon className={"size-[1.4vw] max-lg:size-[5.45vw]"} />
                </div>
              </div>
              <span className="text-black  max-lg:opacity-25 text-[1vw] max-lg:text-[3.73vw] font-luxora-regular font-normal leading-[1.1]">
                {name}
              </span>
            </div>
          ) : (
            <Link
              target={isBlank ? "_blank" : ""}
              className="navigation-link font-luxora-regular w-full p-[0.571vw] max-lg:p-[2.13vw] hover:bg-hoverBg flex items-center gap-[0.8vw] max-lg:gap-[3.2vw] rounded-2xl transition-colors duration-300"
              to={url}
            >
              <div className="size-[2vw] max-lg:size-[7.46vw] flex items-center justify-center rounded-lg bg-white shadow-custom">
                <div>
                  <Icon className="size-[1.4vw] max-lg:size-[5.45vw]" />
                </div>
              </div>
              <span className="text-black text-[1vw] font-luxora-regular max-lg:text-[3.73vw] font-normal leading-[1.1]">
                {name}
              </span>
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
};

export default EcosystemItems;
